export default "__VITE_ASSET__DdkxhxMi__"